import { $regraEntidade, $regraAcao } from '@/custom-enum/regras-enum.js'

export default [
    {
      path: '/sesi-outros-produtos',
      name: 'sesi-listar-outros-produtos',
      meta: {
          resource: $regraEntidade.rotas.protegida,
          subject: $regraEntidade.portal.outrosProdutos.sesi,
          action: $regraAcao.visualizar,
          layout: 'normal',
          title: 'SESI - Outros Produtos'
      },
      component: () =>
          import ('@/views/pages/outros-produtos/usuario-sesi/listagemOutrosProdutos.vue'),
    }
]
